import { Typography } from "@mui/material"
import type { BiomeshEventResponse } from "@phc/common/gen/threatAnalyticsGen"
import {
  getListEventsBiomeshEventListGetQueryKey,
  useDeleteEventBiomeshEventEventIdDelete,
} from "@phc/common/gen/threatAnalyticsGen"
import { useQueryClient } from "@tanstack/react-query"
import { enqueueSnackbar } from "notistack"
import type { FC } from "react"
import { useCallback } from "react"
import { Modal } from "../Shared/Modal"
import { extractApiError } from "./copUtils"

interface DeleteEventDialogProps {
  open: boolean
  onClose: () => void
  event: BiomeshEventResponse
}

export const DeleteEventDialog: FC<DeleteEventDialogProps> = ({
  open,
  onClose,
  event,
}) => {
  const queryClient = useQueryClient()
  const { mutateAsync: deleteEvent, isPending } =
    useDeleteEventBiomeshEventEventIdDelete()

  const handleConfirm = useCallback(async () => {
    try {
      await deleteEvent({ eventId: event.event_id })
      await queryClient.invalidateQueries({
        queryKey: getListEventsBiomeshEventListGetQueryKey(),
      })
      enqueueSnackbar("Event deleted", { variant: "success" })
      onClose()
    } catch (err) {
      enqueueSnackbar(extractApiError(err, "Failed to delete event"), {
        variant: "error",
      })
    }
  }, [deleteEvent, event.event_id, queryClient, onClose])

  return (
    <Modal
      open={open}
      onClose={onClose}
      onConfirm={() => void handleConfirm()}
      title="Delete Event"
      confirmLabel="Delete"
      disableBtns={isPending}
    >
      <Typography sx={{ mt: 1 }}>
        Are you sure you want to delete <strong>{event.name}</strong>?
      </Typography>
    </Modal>
  )
}
